import React from "react";
import { BlockConfig } from "../BuilderContext";
import { Scissors } from "lucide-react";

const PageBreakBlock: React.FC<{ block: BlockConfig }> = ({ block: _block }) => {
  return (
    <div className="py-2 print:hidden">
      <div className="flex items-center gap-3">
        <div className="flex-1 border-t-2 border-dashed border-slate-300" />
        <span className="flex items-center gap-1.5 text-xs uppercase tracking-wider text-slate-400 select-none">
          <Scissors className="w-3.5 h-3.5" />
          Page Break
        </span>
        <div className="flex-1 border-t-2 border-dashed border-slate-300" />
      </div>
    </div>
  );
};

export default PageBreakBlock;
